module.exports = __webpack_public_path__ + "static/feather-6-2b4e384f63db1641ed2a9d5abae661c5.png";